type SetPrevPathAction = {
  type: "SET_PREV_PATH";
  payload: string;
};

export const setPrevPath = (prevPath: string): SetPrevPathAction => ({
  type: "SET_PREV_PATH",
  payload: prevPath
});

export default setPrevPath;
